import { combineReducers } from 'redux';
import auth from './auth';
import modalWindows from './modalWindows';
import user from './user';

const rootReducer = combineReducers({
  auth,
  modalWindows,
  user
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js